export const getWordCount = (str) => {
  if (str && str !== '') {
    return str.trim().split(/\s+/).length;
  }
  return 0;
};
